// export { default as ContactUs } from './contact-us/index';
// export { default as Home } from './home/index';
// export { default as Vehicle } from './vehicle/index';
// export { default as VehicleDetails } from './vehicle-details/index';
// export { default as Trips } from './trips/index';
// export { default as TripDetails } from './trip-details/index';
// export { default as HowItWorks } from './how-it-works/index';
// export { default as Reservations } from './reservations/index';
// export { default as Locations } from './locations/index';
// export { default as Rent } from './rent/index';
// export { default as Profile } from './profile/index';
import { lazy } from 'react';

export const ContactUs = lazy(() => import('./contact-us/index'));
export const Home = lazy(() => import('./home/index'));
export const Vehicle = lazy(() => import('./vehicle/index'));
export const VehicleDetails = lazy(() => import('./vehicle-details/index'));
export const Trips = lazy(() => import('./trips/index'));
export const TripDetails = lazy(() => import('./trip-details/index'));
export const HowItWorks = lazy(() => import('./how-it-works/index'));
export const Reservations = lazy(() => import('./reservations/index'));
export const Locations = lazy(() => import('./locations/index'));
export const Rent = lazy(() => import('./rent/index'));
export const Profile = lazy(() => import('./profile/index'));